/**
 * Los destinos de la navegación, para la barra inferior del celular (`TabsPage`) y la barra
 * lateral de PC (`SideNavComponent`). Salen de aquí para que las dos no se desincronicen.
 *
 * Los diarios son pestañas de `/tabs` (cada una a un toque). Comanda y Analíticas son del
 * canal delivery: sin él se ocultan, como siempre (`showsDeliveryTabs`, `DeliveryGuard`).
 */
export interface NavItem {
  /** El nombre de la pestaña en `/tabs/<tab>`; solo los diarios. */
  tab?: string;
  url: string;
  icon: string;
  /** Clave de traducción. */
  label: string;
}

const DAILY: (NavItem & { tab: string; delivery: boolean })[] = [
  { tab: 'tab1', url: '/tabs/tab1', icon: 'receipt-outline', label: 'Orders', delivery: true },
  { tab: 'products', url: '/tabs/products', icon: 'pricetags-outline', label: 'Catalog', delivery: false },
  { tab: 'tab2', url: '/tabs/tab2', icon: 'analytics-outline', label: 'Analytics', delivery: true },
  { tab: 'tab3', url: '/tabs/tab3', icon: 'person-outline', label: 'Account', delivery: false }
];

export function dailyNavItems(deliveryActive: boolean): NavItem[] {
  return DAILY.filter((item) => deliveryActive || !item.delivery).map(({ tab, url, icon, label }) => ({
    tab,
    url,
    icon,
    label
  }));
}

/**
 * «Mi negocio»: lo que se configura de vez en cuando. En el celular, desde Cuenta. Las
 * categorías no van aquí: se manejan dentro de la Carta (etapa 3).
 */
export const BUSINESS_NAV_ITEMS: readonly NavItem[] = [
  { url: '/venue-profile', icon: 'create-outline', label: 'Venue Profile' },
  { url: '/storefront', icon: 'storefront-outline', label: 'My storefront and channels' }
];
